import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class FixedAssetAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'FixedAssets';

  /**
   * Dữ liệu tài sản
   * TPNAM 28.12.2022
   */
  async getFixedAssetIncrement() {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetFixedAssetIncrement'
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy các chứng từ liên quan
   * @param {*} payload
   * @returns
   * NNKiem 30.01.2022
   */
  async getVoucherReference(payload) {
    let apiUrl = this.getAPIUrl();
    let request = { url: `${apiUrl}/VoucherReference`, data: payload };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy lại trạng thái ghi tăng, ghi giảm, điều chỉnh của TSCĐ
   * @param {*} payload
   * @returns
   */
  async getStatusIncrementFixedAsseet(payload) {
    let request = { url: this.getAPIUrl() + '/StatusIncrement', data: payload };
    return await httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách tài sản đã ghi tăng
   * TPNAM 19.01.2023
   */
  loadIncrementFixedAsset(payload) {
    let request = {
      url: this.getAPIUrl() + '/listIncrementFixedAsset',
      data: payload
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách tài sản đã ghi tăng
   * dqdat1 06.04.2023
   */
  loadIncrementBookFixedAsset(payload) {
    let request = {
      url: this.getAPIUrl() + '/listIncrementBookFixedAsset',
      data: payload
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách ts
   * Created by NNKiem 13.03.2023
   */
  GetDatabyListFixedAssetByCode(payload) {
    let request = {
      url: this.getAPIUrl() + '/ListFixedAssetByCode',
      data: payload
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách ts theo thông tư 23
   * NBTIN 23.05.2023
   */
  getDataFixedAssetUpdateTT23(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataFixedAssetUpdateTT23',
      data: payload
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách ts theo thông tư 23
   * NBTIN 23.05.2023
   */
  getVoucherFixedAssetUpdateTT23(payload) {
    let request = {
      url: this.getAPIUrl() + '/VoucherFixedAssetUpdateTT23',
      data: payload
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách ts theo thông tư 23
   * NBTIN 23.05.2023
   */
  updateCircularTT23(payload) {
    let request = {
      url: this.getAPIUrl() + '/UpdateCircularTT23',
      data: payload
    };

    return httpClient.postAsync(request);
  }
  /**
   * Kiểm tra có cần show form cập nhật thông tư 23 không
   * TVDAT 30/05/2023
   */
  checkUpdateTT23() {
    let request = {
      url: this.getAPIUrl() + '/CheckUpdateTT23',
      data: null
    };
    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra xem trạng thái TT23 đã cập nhật chưa
   * NCQUYEN 05/06/2023
   */
  checkStatusTT23() {
    let request = { url: this.getAPIUrl() + '/checkStatusTT23', data: null };
    return httpClient.getAsync(request);
  }

  /**
   * Update thông tư 76
   * NCQUYEN 28/06/2023
   */
  updateTT76() {
    let request = { url: this.getAPIUrl() + '/updateTT76', data: null };
    return httpClient.getAsync(request);
  }
}

export default new FixedAssetAPI();
